document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const dateSource = document.querySelector('.product-status-bar[data-giorni], .doubleusps[data-giorni]');
    const cstmDate = document.getElementById('cstmdate');

    if (!dateSource || !cstmDate) {
      return;
    }

    const giorniDellaSettimana = dateSource.dataset.giorni.split(',');
    const mesi = dateSource.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    cstmDate.innerText = dataFormattata;

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});

var coll = document.getElementsByClassName("u-accordion-item-title");
        var i;
        for (i = 0; i < coll.length; i++) {
         coll[i].addEventListener("click", function() {
         this.classList.toggle("active");
         var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

(() => {
  const rebuyLabelSelector = '#rebuy-cart .rebuy-cart__progress-bar-meter-label, #rebuy-cart .rebuy-cart__progress-bar-prompt';
  const cartOpenTriggerSelector = 'a[href="/cart"], a[href$="/cart"], [aria-controls="cart-drawer"], [aria-controls="rebuy-cart"], [data-rebuy-cart], [data-rebuy-cart-toggle], .rebuy-cart-toggle';
  const orthosleepHandles = new Set(['cuscino']);
  const orthosleepTitlePattern = /orthosleep/i;
  const orthosleepSinglePriceCents = 5995;
  const freeShippingThresholdCents = 8000;
  const iceSilkPriceCents = 2095;
  const iceSilkMessage = 'Aggiungi la federa Ice Silk a €20,95 e sblocca la spedizione gratuita.';

  let cartSnapshot = null;
  let cartRequest = null;
  let updateTimer = null;
  let isApplyingMessage = false;

  const getRebuyLabels = () => Array.from(document.querySelectorAll(rebuyLabelSelector));

  const normalizeHandle = (handle) => (handle || '').normalize('NFKC');

  const getLinePrice = (item) => Number(item.final_line_price) || Number(item.line_price) || 0;

  const parseMoneyToCents = (value) => {
    const normalizedValue = value.replace(/\./g, '').replace(',', '.');
    const parsedValue = Number.parseFloat(normalizedValue);

    return Number.isFinite(parsedValue) ? Math.round(parsedValue * 100) : null;
  };

  const isOrthoSleepItem = (item) => (
    orthosleepHandles.has(normalizeHandle(item.handle))
    || orthosleepTitlePattern.test(`${item.product_title || ''} ${item.title || ''}`)
  );

  const getShippingSubtotal = (cart) => {
    const shippingItemsTotal = (cart.items || [])
      .filter((item) => item.requires_shipping)
      .reduce((total, item) => total + getLinePrice(item), 0);
    const cartDiscount = (cart.cart_level_discount_applications || [])
      .reduce((total, discount) => total + (Number(discount.total_allocated_amount) || 0), 0);

    return shippingItemsTotal - cartDiscount;
  };

  const shouldShowIceSilkMessage = (cart) => {
    if (!cart?.items?.length) return false;

    const paidItems = cart.items.filter((item) => getLinePrice(item) > 0);
    const [paidItem] = paidItems;
    const hasOnlyOnePaidOrthoSleep = paidItems.length === 1
      && Number(paidItem.quantity) === 1
      && isOrthoSleepItem(paidItem);
    const shippingSubtotal = getShippingSubtotal(cart);

    return hasOnlyOnePaidOrthoSleep
      && shippingSubtotal < freeShippingThresholdCents
      && shippingSubtotal + iceSilkPriceCents >= freeShippingThresholdCents;
  };

  const shouldShowIceSilkMessageFromRebuyDom = () => {
    const rebuyCart = document.getElementById('rebuy-cart');
    const cartText = rebuyCart?.textContent || '';
    const totalMatch = cartText.match(/Totale[\s\S]*?([0-9]{1,3}(?:\.[0-9]{3})*,[0-9]{2})/i);

    if (!orthosleepTitlePattern.test(cartText) || !totalMatch) return false;

    return parseMoneyToCents(totalMatch[1]) === orthosleepSinglePriceCents;
  };

  const fetchCart = async () => {
    if (cartRequest) return cartRequest;

    cartRequest = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        cartSnapshot = cart;
        return cart;
      })
      .catch((error) => {
        console.warn('[Ice Silk cart message] Impossibile leggere il carrello.', error);
        return null;
      })
      .finally(() => {
        cartRequest = null;
      });

    return cartRequest;
  };

  const applyRebuyMessage = (enabled) => {
    isApplyingMessage = true;

    getRebuyLabels().forEach((label) => {
      if (enabled) {
        if (!label.dataset.sereniumOriginalText) {
          label.dataset.sereniumOriginalText = label.textContent.trim();
        }

        label.textContent = iceSilkMessage;
        label.dataset.sereniumIceSilkMessage = 'true';
        return;
      }

      if (label.dataset.sereniumIceSilkMessage === 'true' && label.textContent.trim() === iceSilkMessage) {
        label.textContent = label.dataset.sereniumOriginalText || label.textContent;
      }

      delete label.dataset.sereniumOriginalText;
      delete label.dataset.sereniumIceSilkMessage;
    });

    window.requestAnimationFrame(() => {
      isApplyingMessage = false;
    });
  };

  const updateRebuyMessage = async (cart = cartSnapshot) => {
    if (!getRebuyLabels().length) return;

    const currentCart = cart || await fetchCart();
    applyRebuyMessage(shouldShowIceSilkMessage(currentCart));
  };

  const scheduleUpdate = (cart, forceFetch = false) => {
    if (cart) cartSnapshot = cart;

    if (!cart && forceFetch && shouldShowIceSilkMessageFromRebuyDom()) {
      applyRebuyMessage(true);
    }

    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(() => updateRebuyMessage(forceFetch ? null : cartSnapshot), 0);
  };

  const mutationTouchesRebuyCart = (mutation) => {
    const rebuyCart = document.getElementById('rebuy-cart');

    if (mutation.type === 'attributes' && document.body.classList.contains('rebuy-cart-visible')) return true;
    if (rebuyCart && rebuyCart.contains(mutation.target) && mutation.removedNodes.length > 0) return true;

    return Array.from(mutation.addedNodes).some((node) => (
      node.nodeType === 1
      && (node.id === 'rebuy-cart' || node.matches?.(rebuyLabelSelector) || node.querySelector?.(rebuyLabelSelector))
    ));
  };

  document.addEventListener('cart:change', (event) => scheduleUpdate(event.detail?.cart));
  document.addEventListener('cart:refresh', () => {
    cartSnapshot = null;
    scheduleUpdate(null, true);
  });
  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest?.(cartOpenTriggerSelector)) return;

    scheduleUpdate(null, true);
  }, { capture: true });

  const observer = new MutationObserver((mutations) => {
    if (isApplyingMessage) return;
    if (!mutations.some(mutationTouchesRebuyCart)) return;

    scheduleUpdate(null, true);
  });

  const startObserver = () => {
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    scheduleUpdate(null, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();

var swiper = new Swiper(".mprogSwiper", {
      pagination: {
        el: ".swiper-pagination",
      },
  navigation: {
    nextEl: ".m-swiper-button-next",
    prevEl: ".m-swiper-button-prev",
  },
});